import { FormalizationPanel } from './formalization';
import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { FgtsAdm } from './fgts';
import { CltSettings } from './clt';
import { MaxSettings } from './max';
import { BulkStateBroadcast } from './bulkstate';
import { TelegramPaidNotifyPanel } from './telegrampaid';
import { AdminDashboardRefactored } from '../admin/AdminDashboardRefactored';
import { BotErrorLogsPanel } from './boterrors';
import { HumanSalesAdmin } from '../humansales/admin';

export  function AdmPage() {
  const [value, setValue] = React.useState(window.location.hash === '#formalizacao' ? '7' : '1');

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList variant="scrollable" scrollButtons="auto" onChange={handleChange} aria-label="lab API tabs example">
            <Tab label="Fgts" value="1" />
            <Tab  disabled={false} label="Clt" value="2" />
            <Tab disabled={false} label="Max" value="3" />
            <Tab disabled={false} label="Notificaçoes" value="4" />
            <Tab disabled={false} label="Contas" value="5" />
            <Tab disabled={false} label="Erros do Bot" value="6" />
            <Tab label="Formalização" value="7" />
            <Tab label="Atendimento" value="8" />
          </TabList>
        </Box>
        <TabPanel value="1"><FgtsAdm/></TabPanel>
        <TabPanel value="2"><CltSettings/></TabPanel>
        <TabPanel value="3"><MaxSettings/></TabPanel>
        <TabPanel value="4">
          <TelegramPaidNotifyPanel/>
          <hr style={{ margin: '24px auto', maxWidth: 520, border: 'none', borderTop: '1px solid #00000020' }} />
          <BulkStateBroadcast/>
        </TabPanel>
        <TabPanel value="5"><AdminDashboardRefactored/></TabPanel>
        <TabPanel value="6"><BotErrorLogsPanel/></TabPanel>
        <TabPanel value="7"><FormalizationPanel/></TabPanel>
        <TabPanel value="8"><HumanSalesAdmin/></TabPanel>
      </TabContext>
    </Box>
  );
}
